import React from "react";
import { Link } from "@/lib/router-compat";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { calculatorConfig, type CalculatorKind } from "@/pages/kalkylatorer/KalkylatorPage";

/** Offertkategorins slug → kalkylator. Kategorier utan kalkylator saknas här. */
export const calculatorKindBySlug: Record<string, CalculatorKind> = {
  solceller: "solceller",
  hembatterier: "batterier",
  varmepumpar: "varmepumpar",
  laddboxar: "laddboxar",
};

/** Kalkylatorn inbäddad på tjänstens huvudsida, med länk till den egna sidan. */
const CategoryCalculatorSection = ({ kind }: { kind: CalculatorKind }) => {
  const config = calculatorConfig[kind];

  return (
    <div className="page-container py-12 md:py-16">
      <config.Component />
      <div className="mt-6 flex justify-center">
        <Button asChild variant="outline">
          <Link to={config.path}>
            Öppna {config.title.toLowerCase()} <ArrowRight className="ml-2" size={16} />
          </Link>
        </Button>
      </div>
    </div>
  );
};

export default CategoryCalculatorSection;
